export default {
  /**
   * @property {string} default
   */
  default: `Hind`
};
